import { Group, Root, Separator, Slot } from './InputOTP.parts';

export const InputOTP = Object.assign(Root, {
  Group,
  Slot,
  Separator,
});
InputOTP.displayName = 'InputOTP';
